// §5.7 — the skin's window frames, portalled into each host's `.win-chrome` slot.
//
// A portal renders into an existing node; it never creates or moves one. That is what lets the
// frame re-render on focus, on a title change and on a skin change while `.win-host` — and the
// app inside it — sit completely still.
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useWindows } from '@/kernel/react';
import { useSkin } from './SkinProvider';
import { noteRender } from './debug';
import type { HostSlots } from './AppHost';

export function WindowFrameLayer({ slots }: { slots: ReadonlyMap<string, HostSlots> }) {
  const skin = useSkin();
  const windows = useWindows();
  const WindowFrame = skin.components.WindowFrame;

  // §20's drag budget is counted here: this layer re-renders on any window change, so one call
  // per commit is exactly what "≤ 2 React commits during a 200-step drag" is measuring. No dep
  // array — the point is to count commits, not changes.
  useEffect(() => {
    noteRender();
  });

  return (
    <>
      {windows.map((win) => {
        const slot = slots.get(win.instanceKey);
        if (!slot) return null;
        return (
          <div key={win.instanceKey}>
            {createPortal(<WindowFrame win={win} />, slot.chrome)}
          </div>
        );
      })}
    </>
  );
}
